module.exports = __webpack_public_path__ + "static/media/tether-cable.b6961828.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/features/tether-cable.png
// module id = 280
// module chunks = 0